import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { messages } from './messages'
import moment from 'moment'
Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'pt-BR'

moment.locale(locale)

const i18n = new VueI18n({ locale, messages })

export default i18n
